import { supportedLocales } from "@cronika/locales";

export const ROUTES = {
  HOME: "/",
  SIGN_IN: "/auth/sign-in",
  SIGN_UP: "/auth/sign-up",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
  SETTINGS: "/settings",
  WALLET: "/wallet",
  HISTORY: "/history",
  INSTALL_APP: "/install-app",
  ACCESS_DENIED: "/access-denied",
  NOT_FOUND: "/not-found",

  PAYMENT_SUCCESS: "/deposit/success",
  PAYMENT_CANCEL: "/deposit/cancel",
  MAINTENANCE: "/maintenance",
  STATS_UNSUBSCRIBE: "/stats-unsubscribe",
  NEWS_UNSUBSCRIBE: "/news-unsubscribe",

  COPY_TRADING: "/copy-trading",
  HELP_CENTER: "/help-center",
  RESTORE_ACCOUNT: "/restore-account",
  SESSION_COUNTER_WIDGET: "/session-counter-widget",
};

export const withLocale = (path: string, explicitLocale?: string): string => {
  const supported: readonly string[] = supportedLocales;

  // Try to get locale from various sources
  const fromArg = explicitLocale && supported.includes(explicitLocale) ? explicitLocale : undefined;

  const fromCookie =
    typeof document !== "undefined"
      ? document.cookie
          .split("; ")
          .find((c) => c.startsWith("locale="))
          ?.split("=")[1]
      : undefined;

  const fromStorage = typeof window !== "undefined" ? window.localStorage.getItem("locale") || undefined : undefined;

  const fromUrl =
    typeof window !== "undefined"
      ? (() => {
          const segments = window.location.pathname.split("/");
          const potentialLocale = segments[1] ?? "";
          return supported.includes(potentialLocale) ? potentialLocale : undefined;
        })()
      : undefined;

  const current = fromArg || fromUrl || fromCookie || fromStorage;
  const locale = supported.includes(current || "") ? (current as string) : "en";

  // Ensure path starts with /
  const clean = path.startsWith("/") ? path : `/${path}`;

  // Return path prefixed with locale
  return `/${locale}${clean}`;
};
